export const getCategories = (state, categories) => {
  state.categories = categories
}

export const setLoading = (state, value) => {
  state.loading = value;
}